import type { Modules } from '~/types/equipment';

import installationRiskHttp from '~/services/installation-risk-api/installation-risk-api.http';

class ModulesService {
  private readonly endpoint = '/v1/modules';

  private static buildQueryString(params: any): string {
    const searchParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, value.toString());
      }
    });

    return searchParams.toString();
  }

  async create(data: Modules.CreateModuleRequest): Promise<Modules.Module> {
    const response = await installationRiskHttp.post(this.endpoint, data);
    return response.data;
  }

  async getById(id: number): Promise<Modules.Module> {
    const response = await installationRiskHttp.get(`${this.endpoint}/${id}`);
    return response.data;
  }

  async list(params: Modules.GetModulesRequest): Promise<any> {
    const queryString = ModulesService.buildQueryString(params);
    const url = queryString ? `${this.endpoint}?${queryString}` : this.endpoint;
    const response = await installationRiskHttp.get(url);
    return response.data;
  }

  async update(id: number, data: Modules.UpdateModuleRequest): Promise<Modules.Module> {
    const response = await installationRiskHttp.put(`${this.endpoint}/${id}`, data);
    return response.data;
  }
}

const modulesService = new ModulesService();

export default modulesService;
